import { RecordType } from "graphql/generated/graphql";
import {
    bundleItemTypeList,
    projectItemTypeList,
    recordList,
    workspaceItemTypeList,
} from "utils/utils";

// "all" tabs are used in TrashBin
const mainTabsCorrectOrder = {
    all: ["flow", "connector", "schedule", "webhook", "setting", "file", "custom_object"],
    workspace: ["project", "bundle", "chat", "user", "role"],
    project: ["flow", "connector", "schedule", "webhook", "setting", "file", "custom_object"],
    bundle: ["flow", "connector", "schedule", "setting", "file", "plugin", "custom_object"],
};

const commonTypeFilter = (type) =>
    type !== "USER" &&
    type !== "WORKSPACE" &&
    type !== "ORGANIZATION" &&
    type !== "EXECUTION" &&
    type !== "MESSAGE" &&
    type !== "OAUTH" &&
    type !== "TAG";

const graphqlList = {
    all: {
        list: recordList,
        filter: commonTypeFilter,
    },
    workspace: {
        list: workspaceItemTypeList,
        filter: (type) => type !== "PROCESS" && type !== "WORKSPACE" && type !== "ORGANIZATION",
    },
    project: {
        list: projectItemTypeList,
        filter: commonTypeFilter,
    },
    bundle: { list: bundleItemTypeList, filter: commonTypeFilter },
};

const sortInCorrectOrder = (elems: RecordType[], sortedData) =>
    elems.sort((a, b) => {
        const textA = sortedData.indexOf(a.toLowerCase());
        const textB = sortedData.indexOf(b.toLowerCase());
        if (textA < textB) return -1;
        if (textA > textB) return 1;
        return 0;
    });

const getTabList = (tab) => {
    const filteredResourceList = graphqlList[tab].list.filter((type) =>
        graphqlList[tab].filter ? graphqlList[tab].filter(type) : {}
    );
    const tabs: { mainTab: RecordType[]; moreTab: RecordType[] } = filteredResourceList.reduce(
        (acc: { mainTab: RecordType[]; moreTab: RecordType[] }, currentType: RecordType) => {
            if (mainTabsCorrectOrder[tab].indexOf(currentType.toLowerCase()) > -1) {
                acc["mainTab"].push(currentType);
            } else {
                acc["moreTab"].push(currentType);
            }
            return acc;
        },
        { mainTab: [], moreTab: [] }
    );
    return {
        mainTab: sortInCorrectOrder(tabs.mainTab, mainTabsCorrectOrder[tab]),
        moreTab: tabs.moreTab.sort(),
    };
};

export const shownTabList = {
    all: getTabList("all").mainTab,
    workspace: getTabList("workspace").mainTab,
    project: getTabList("project").mainTab,
    bundle: getTabList("bundle").mainTab,
};

export const moreTabList = {
    all: getTabList("all").moreTab,
    workspace: getTabList("workspace").moreTab,
    project: getTabList("project").moreTab,
    bundle: getTabList("bundle").moreTab,
};

export const recordsInTrash = [...shownTabList.all, ...moreTabList.all];
